"use client";

import styles from "./VerificationPageHeader.module.scss";
import { WEBSITE_URL } from "@/constants";
import { logoutUser } from "@/helpers";

import { useTranslations, useLocale } from "@/i18n";
import { Flex } from "@vetty/ui";

export const VerificationPageHeader = () => {
  const t = useTranslations("verification.header");
  const locale = useLocale();

  return (
    <Flex align={"center"} justify={"space-between"} className={styles["comp"]}>
      <a href={`${WEBSITE_URL}/${locale}`} className={styles["comp__logo-link"]}>
        <img
          className={styles["comp__logo"]}
          src="/assets/logo-dark.svg"
          alt="Vetty"
        />
      </a>

      <Flex align={"center"} gap={36} className={styles["comp__menu"]}>
        <a
          href={`${WEBSITE_URL}/${locale}/contact`}
          className={styles["comp__menu__item"]}
        >
          {t("contact")}
        </a>

        <button onClick={logoutUser} className={styles["comp__menu__item"]}>
          {t("logOut")}
        </button>
      </Flex>
    </Flex>
  );
};
